import { isEmpty } from 'lodash';

import { Alert } from './alert';

export const transferResponseHandler = (response) => {
  if (isEmpty(response.failTransferData)) {
    Alert.fire({
      icon: 'success',
      title: "All start-packs' iccids are transferred",
    });
  } else {
    const content = `
            ${response.failTransferData.map(
              (item) => `<li>The iccid ${item.iccid} currently on ${item.partnerName}</li>`
            )}`;
    Alert.fire({
      icon: 'warning',
      title: "Some start-packs' iccids are not transferred",
      html: `<ul>${content}</ul>`,
    });
  }
};
